import request from '@/utils/request'

// 查询企业信息列表
export function listQyjbxx(query) {
  return request({
    url: '/web/xwqy/qyjbxx/list',
    method: 'get',
    params: query
  })
}

//根据uniscid获取记录
export function getOne(query) {
  return request({
    url: '/web/xwqy/qyjbxx/getOne',
    method: 'get',
    params: query
  })
}